export const TextAreaResizeIcon: React.FC = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 12 12"
      fill="none"
      width="12"
      height="12"
    >
      <path
        d="M1 11.2929L11.2929 1M5 11.2929L11.2929 5M9 11.2929L11.2929 9"
        stroke="var(--inzeloop-ds-color-icon-primary)"
        strokeLinecap="round"
      />
    </svg>
  );
};
